/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Price_Free_AddInputs */



/**
* | output |
* | --- |
* | "The new member takes a {type} seat you already pay for." |
*
* @param {Seat_Price_Free_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_free_add = /** @type {((inputs: Seat_Price_Free_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Free_AddInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das neue Mitglied erhält einen ${i?.type}-Platz, den Sie bereits bezahlen.`)
	return /** @type {LocalizedString} */ (`The new member takes a ${i?.type} seat you already pay for.`)
});